import { useState } from 'react'
import PropTypes from 'prop-types'

export default function FileListItem({
  name,
  status,
  currentSelected,
  isSelected,
  validationMessage,
  isItemUploaded,
  onSelect,
  onClick,
}) {
  const [hidden, setHidden] = useState(true)
  const isProjectUploading = status === 'uploading'
  const isProjectDoneUploading = status === 'success'
  const inEditMode = !isProjectUploading && !isProjectDoneUploading

  const handleHover = () => {
    if (!isSelected) {
      setHidden(false)
    }
  }

  const handleLeave = () => {
    if (!isSelected) {
      setHidden(true)
    }
  }

  const toggleChecked = event => {
    if (isSelected && !currentSelected) {
      event.stopPropagation()
    }

    if (!isSelected && currentSelected) {
      event.stopPropagation()
    }

    if (!isSelected) {
      setHidden(true)
    }
    if (inEditMode) {
      onSelect(event.shiftKey)
    }
  }

  return (
    (
      <div
        onMouseOver={handleHover}
        onMouseLeave={handleLeave}
        onClick={onClick}
        className={`
        tw-px-5
        tw-py-3
        tw-border-b
        tw-border-solid
        tw-border-t-0
        tw-border-r-0
        tw-border-l-0
        tw-border-system-grey-200
        tw-flex 
        tw-justify-between
        tw-items-center
        ${isProjectUploading ? 'tw-cursor-not-allowed' : 'tw-cursor-pointer'}
        ${currentSelected ? 'tw-bg-system-grey-100' : ''}`}>
        <div className="tw-flex tw-overflow-hidden">
          <div
            onClick={toggleChecked}
            className={`tw-mb-0 tw-text-sm tw-normal-case`}>
            <span
              className={`
          tw-my-auto
          tw-inline-block
          tw-w-4
          tw-h-4
          tw-border-2 
          tw-border-solid
          tw-rounded-sm
          tw-duration-100 
          tw-ease-linear
          tw-leading-none
          ${(!isSelected && hidden) || !inEditMode ? 'tw-opacity-0' : ''}
          ${
            isSelected && inEditMode
              ? 'tw-border-primary tw-bg-primary'
              : `${
                  !inEditMode
                    ? 'tw-border-system-grey-100'
                    : 'tw-border-system-grey-400'
                } tw-bg-white`
          }
          `}>
              {isSelected && inEditMode && (
                <svg
                  className={`
            tw-duration-100 
            tw-ease-linear 
            tw-fill-current 
            tw-text-white 
            tw-pointer-events-none`}
                  viewBox="0 0 20 20">
                  <path d="M0 11l2-2 5 5L18 3l2 2L7 18z"></path>
                </svg>
              )}
            </span>
          </div>
          <span className="tw-ml-2 tw-truncate">{name}</span>
        </div>
        {inEditMode && !isItemUploaded ? (
          validationMessage && (
            <i
              className="tw-text-danger fas fa-exclamation-triangle"
              title={validationMessage}
            />
          )
        ) : (
          <ProgressIndicator done={isItemUploaded} />
        )}
      </div>
    ) || <></>
  )
}

function ProgressIndicator({ done }) {
  return (
    <span
      className={`
    tw-h-4 
    tw-w-4 
    tw-rounded-full 
    tw-border-2 
    tw-border-solid
    tw-flex-shrink-0
    tw-ml-2
    ${
      done
        ? 'tw-bg-success tw-border-success'
        : 'tw-bg-white tw-border-system-grey-200'
    }
    `}
      title={done ? 'Successfully uploaded' : null}
    />
  )
}

ProgressIndicator.propTypes = {
  done: PropTypes.bool,
}

FileListItem.propTypes = {
  name: PropTypes.string.isRequired,
  status: PropTypes.string,
  currentSelected: PropTypes.bool,
  validationMessage: PropTypes.string,
  isItemUploaded: PropTypes.bool,
  lastSelected: PropTypes.string,
  groupKey: PropTypes.string,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
}
